import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
// import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Injectable({
  providedIn: 'root'
})
export class BadWordsApiService {

  constructor(
    private http: HttpClient
  ) { }

  public addBadWords(word): Observable<any> {
    return this.http.post(APIConstants.BADWORDSDATA, word)

  }

  // checking the bad words
  public checkBadWord(word): Observable<any> {
    console.log("inside the service call", word);
    return this.http.get(APIConstants.BADWORDSDATACHECK + '?Restricted_Words=' + word);
  }

  // getting the data from mongodb

  public getRestrictedWords(): Observable<any> {
    return this.http.get(APIConstants.GETALLRESTRICTEDWORDS)
  }
// to delete the restricted words from mongodb
  public deleteRestrictedWords(words):Observable<any>
  {
console.log("delete restricted words in service file",words);
    return this.http.get(APIConstants.DELETERESTRICTEDWORDS+ '?Restricted_Words=' + words)
  }

// upload the list of restricted words

public uploadRestrictedFile(file):Observable<any>
{
  console.log("inside the service method",file)
  const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');
        headers.set('Access-Control-Allow-Origin',"*");
        
  return this.http.post(APIConstants.UPLOADRESTRICTEDWORDS,file, { headers })
}
}